$(function () {
  if (Cookies.get('cookies-accepted') != 1) {
    if ($('.js-cookies').length) {
      setTimeout(function () {
        $('.js-cookies').addClass('is-display');
        $('.js-cookies-close').on('click', function () {
          $('.js-cookies').removeClass('is-display');
          Cookies.set('cookies-accepted', '1', { expires: 365 });
        });
      }, 1500);
    }
  }
});